import {UntypedFormControl} from '@angular/forms';

export function passwordValidator(control: UntypedFormControl): {[key: string]: any} | undefined {
  if (control.value) {

    const password = control.value;

    let hasError = false;
    if (password.length < 6) {
      hasError = true;
    }
    if (!password.match(/[A-Z]/g)) {
      hasError = true;
    }
    if (!password.match(/[0-9]/g)) {
      hasError = true;
    }
    if (/^[a-zA-Z0-9]+$/.test(password)) {
      hasError = true;
    }

    if (hasError) {
      return { invalidPassword: true };
    }
  }

  return undefined;
}
